__turbopack_context__.v({
  "accordionItem": "styles-module-scss-module__StWe9q__accordionItem",
});
